export default __webpack_public_path__ + "static/media/Depression_NotCelebrityTrend.69acb014.pdf";